/* eslint-disable */
import Backbone from 'backbone';
import ko from 'knockout';
import Promise from 'bluebird';
import _ from 'underscore';
import layoutTemplate from '@bingads-webui-component-legacy/address/template/layout.pug';
import ViewModel from '@bingads-webui-component-legacy/address/viewmodel/index';
import addressService from '@bingads-webui-component-legacy/address/service/addressService';
import withUiBlock from '@bingads-webui-component-legacy/uiblocker/index';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!component/address');
var View = Backbone.View.extend({
  initialize: function (options) {
    this.options = options || ({});
    this.ko_model = new ViewModel(this.options);
    this._getCountries();
  },
  events: {
    'change .CountryCode': '_updateAdminDistricts'
  },
  className: 'address-view',
  render: function () {
    this.$el.html(layoutTemplate());
    ko.applyBindings(this.ko_model, this.el);
    return this;
  },
  toObject: function () {
    var propertyList = this.ko_model.propertyList();
    return _.pick(this.ko_model.toObject(), propertyList);
  },
  validate: function () {
    this.ko_model.isEmptyByDefault(false);
    return this.ko_model.isValid();
  },
  _getCountries: function () {
    var self = this, countryCode = self.ko_model.CountryCode(), provinceName = self.ko_model.ProvinceName();
    self.ko_model.errors.clear();
    Promise.resolve(addressService.load(self.options.culture, countryCode)).then(function (data) {
      const countries = _.map(data.Countries, item => {
        return {
          Key: item.Key,
          Value: i18n.getString(`UserCountry_${item.Key}`)
        };
      });
      self.ko_model.countries(countries);
      if (_.contains(_.pluck(data.Countries, 'Key'), countryCode)) {
        self.ko_model.CountryCode(countryCode);
      } else {
        self.ko_model.CountryCode(_.propertyOf(_.first(data.Countries))('Key'));
      }
      self.ko_model.adminDistricts(data.AdminDistricts);
      if (self.ko_model.hasProvince() && !_.isEmpty(data.AdminDistricts)) {
        self.ko_model.ProvinceName(!_.isEmpty(provinceName) ? provinceName : _.propertyOf(_.first(data.AdminDistricts))('Key'));
      }
    }).catch(function () {
      self.ko_model.errors.add();
    }).finally(withUiBlock(self.$el.parent()));
  },
  _updateAdminDistricts: function () {
    var self = this;
    this.ko_model.isEmptyByDefault(true);
    if (!self.ko_model.hasProvince()) {
      return;
    }
    var countryCode = self.ko_model.CountryCode();
    self.ko_model.errors.clear();
    Promise.resolve(addressService.load(self.options.culture, countryCode)).then(function (data) {
      self.ko_model.adminDistricts(data.AdminDistricts);
      self.ko_model.ProvinceName(!_.isEmpty(data.AdminDistricts) ? _.propertyOf(_.first(data.AdminDistricts))('Key') : '');
    }).catch(function () {
      self.ko_model.errors.add();
    }).finally(withUiBlock(self.$el.parent()));
  },
  preview: function (model) {
    model.CountryName = _.propertyOf(_.find(this.ko_model.countries(), {
      Key: model.CountryCode
    }))('Value');
    if (this.ko_model.hasProvince()) {
      model.ProvinceCode = _.isEmpty(this.ko_model.adminDistricts()) ? model.ProvinceName : _.propertyOf(_.find(this.ko_model.adminDistricts(), {
        Key: model.ProvinceName
      }))('Value');
    }
    return model;
  }
});
export default View;

